module.exports = __webpack_public_path__ + "img/orders-ic.48ff9af3.svg";